/**
 * The application footer — one credit line for every signed-in surface.
 *
 * Styled from the same tokens as the top bar and the sidebar (`bg-surface` on a
 * `border-line` edge, `text-ink-muted` type) so the chrome reads as one piece,
 * topped by the logo's own navy → cyan sweep (`.brand-rule`) and with the
 * developer credit in the brand navy, linking out to airavadweb.solutions. No
 * literal colour here — see src/index.css.
 *
 * The year is read from the clock at render time, so it rolls over on its own.
 *
 * Desktop only (`lg` and up) — it shares the breakpoint with the sidebar, so on
 * phones and tablets the bottom of the screen stays the app-like tab bar.
 */

export function AppFooter({ className = "" }: { className?: string }) {
  const year = new Date().getFullYear();

  return (
    <footer className={`mt-auto hidden shrink-0 border-t border-line bg-surface lg:block ${className}`}>
      {/* The logo gradient as a hairline, echoing the auth screens' top rule. */}
      <div className="brand-rule h-0.5 rounded-none" aria-hidden />

      <p className="px-3 py-3 text-center text-xs text-ink-muted sm:px-5">
        © {year} All Rights Reserved. Developed By{" "}
        <a
          href="https://airavadweb.solutions/"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-brand hover:underline"
        >
          Airavad Web Solutions
        </a>
        .
      </p>
    </footer>
  );
}
